import { render, staticRenderFns } from "./MerchantsProducts.vue?vue&type=template&id=396ba729&"
import script from "./MerchantsProducts.vue?vue&type=script&lang=js&"
export * from "./MerchantsProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports